export const APP_NAME = 'Seek JobApplyFrontend';
export const AUTO_SUGGEST_API_KEY = 'candy-connect';
export const USER_AUTHENTICATED_STATUS = 'authenticated';
export const USER_UNAUTHENTICATED_STATUS = 'unauthenticated';
export const DOCUMENT_PAGE_FORM_NAME = 'documents-page-form';
export const PERSONAL_DETAILS_FORM = 'personal-details-form';
export const MAX_RESUMES_PER_USER = 10;
export const ROLE_REQUIREMENTS_FORM_NAME = 'role-requirements-page-form';
export const MAX_UPLOAD_FILE_SIZE = 2.048;
export const MAX_DOCUMENTS = 10;
export const COVER_LETTER_KEY = 'cover-letter';
export const SELECTION_CRITERIA_KEY = 'selection-criteria';
